import axiosInstance from '../axiosInstance'

// Models
import { Site, SiteID } from '../sites/models/site'
import { ShiftReason, ShiftReasonID, ShiftReasonJson } from './models/shiftReason'
import { Pagination } from '../common/models/pagination'

export interface ShiftReasonSearchForm {
    name?: string
    
    showArchived?: boolean

    perPage: number
    page: number
}

interface ShiftReasonSearchParams {
    name?: string

    show_archived?: boolean

    per_page: number
    page: number
}

export interface ShiftReasonCreateForm {
    name: string
}

interface ShiftReasonCreateData {
    name: string
}

export interface ShiftReasonUpdateForm {
    name?: string
}

interface ShiftReasonUpdateData {
    name?: string
}

export const fetch = async (siteId: SiteID, name: string, perPage: number, page: number, showArchived: boolean = false): Promise<{ shiftReasons: ShiftReason[], pagination: Pagination }> => {
    const params: ShiftReasonSearchParams = {
        per_page: perPage,
        page: page,
    }

    if (name.trim().length > 0) {
        params.name = name
    }

    if (showArchived) {
        params.show_archived = true
    }

    const response = await axiosInstance.get(`api/orgs/${siteId}/reasons`, { params })

    const data = response.data.data as ShiftReasonJson[]

    return {
        shiftReasons: data.map((shiftReason) => {
            return ShiftReason.fromJson(shiftReason)
        }),
        pagination: new Pagination(response.data.meta.pagination)
    }
}

export const show = async (site: Site, shiftReasonId: ShiftReasonID): Promise<{ shiftReason: ShiftReason }> => {
    const response = await axiosInstance.get(`api/orgs/${site.id}/reasons/${shiftReasonId}`)

    const data = response.data.data as ShiftReasonJson

    return {
        shiftReason: ShiftReason.fromJson(data),
    }
}

export const create = async (site: Site, form: ShiftReasonCreateForm): Promise<{ shiftReason: ShiftReason }> => {
    const data: ShiftReasonCreateData = {
        name: form.name,
    }

    const response = await axiosInstance.post(`api/orgs/${site.id}/reasons`, data)

    const ShiftReasonJson = response.data.data as ShiftReasonJson

    return {
        shiftReason: ShiftReason.fromJson(ShiftReasonJson)
    }
}

function updateFormToData(form: ShiftReasonUpdateForm): ShiftReasonUpdateData {
    const data: ShiftReasonUpdateData = {}

    if (form.name && form.name.trim().length > 0) {
        data.name = form.name
    }

    return data
}

export const update = async (site: Site, shiftReason: ShiftReason, form: ShiftReasonUpdateForm): Promise<{ shiftReason: ShiftReason }> => {
    const data = updateFormToData(form)

    const response = await axiosInstance.patch(`api/orgs/${site.id}/reasons/${shiftReason.id}`, data)

    const ShiftReasonJson = response.data.data as ShiftReasonJson

    return {
        shiftReason: ShiftReason.fromJson(ShiftReasonJson)
    }
}

export const archive = async (siteId: SiteID, reasonId: ShiftReasonID): Promise<void> => {
    await axiosInstance.put(`api/orgs/${siteId}/reasons/${reasonId}/archive`)
}

export const restore = async (siteId: SiteID, reasonId: ShiftReasonID): Promise<void> => {
    await axiosInstance.delete(`api/orgs/${siteId}/reasons/${reasonId}/archive`)
}